export default __webpack_public_path__ + "static/media/Image-3.4c8a3683.png";